import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as mediaActions from '../../store/media/actions';
import * as listsActions from '../../store/lists/actions';
import * as reducers from '../../store/reducers';
import * as settings from 'Settings';
import RampUnit from '../../utils/Playwire/RampUnit';
import VideoSiderailPlayer from 'Components/VideoSiderailPlayer';
import ContentCard from 'Components/ContentCard';
import { getQueryStringParams, qsToString } from '../../api';

import { withLocationWrapper } from '../../utils/HOC_LocationWrapper';

import './SearchPage.scss';

class SearchPage extends Component {
  constructor(props) {
    super(props);
    const { search } = props.location;
    const { q = '' } = getQueryStringParams(search);
    this.state = { query: q };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const { fetchMediaLists } = this.props;
    fetchMediaLists('BooksLanding', '/books', {
      'landing-path': '/books',
      'list-ids': 'all_books',
    });
    fetchMediaLists('GamesLanding', '/games', {
      'landing-path': '/games',
      'list-ids': 'all_games',
    });
    fetchMediaLists('VideosLanding', '/videos', {
      'landing-path': '/videos',
      'list-ids': 'all_videos',
    });
  }

  render() {
    const {
      booksList,
      gamesList,
      videosList,
      isLoading,
      location,
    } = this.props;

    const addSearchText = item => ({
      ...item,
      searchString: `${item.title.toLowerCase()} ${item.tagline.toLowerCase()} ${item.briefDescription.toLowerCase()}`,
    });

    const { query } = this.state;
    const filterFunc = item => {
      const lowerQuery = query.toLowerCase();
      return item.searchString.includes(lowerQuery);
    };

    const sections = [
      {
        title: 'Games',
        items: gamesList.map(addSearchText).filter(filterFunc),
      },
      {
        title: 'Books',
        items: booksList.map(addSearchText).filter(filterFunc),
      },
      {
        title: 'Videos',
        items: videosList.map(addSearchText).filter(filterFunc),
      },
    ];

    const topImageSlugs = [
      'helipopper',
      'star-climber',
      'when-pigs-fly',
      'pickle-pop',
    ];

    const bottomImageSlugs = [
      'color-creature',
      'frost-bite',
      'double-hooked',
      'desert-dive',
    ];

    return (
      <main>
        <div className="Page__ContentWrapper">
          <div style={{ width: '100%', maxWidth: '75em', margin: '0 auto' }}>
            <div
              className="SearchPage__character-container"
              style={{ bottom: -25, marginBottom: 0 }}
            >
              {topImageSlugs.map(slug => (
                <img
                  className="SearchPage__character"
                  src={`${settings.ASSETS_URL}/img/characters/${slug}.svg`}
                  alt={slug}
                />
              ))}
            </div>

            <div className="Page__container">
              <div className="SearchPage__Hero" style={{ textAlign: 'center' }}>
                <div>
                  <label htmlFor="SearchInput">
                    <h1 className="HeroSplitPanes__headline">Search</h1>
                    <input
                      id="SearchInput"
                      className="SearchPage__Input"
                      placeholder="Search for games, books, videos, and subjects"
                      type="text"
                      value={query}
                      onChange={e => {
                        const q = e.target.value;
                        this.setState({ query: q });
                        this.props.navigate({
                          pathname: location.pathname,
                          search: `?${qsToString({ q })}`,
                        });
                      }}
                    />
                  </label>
                </div>
              </div>
              {query.length > 2 && (
                <div className="SearchPage__Results">
                  {sections.map(({ title, items }) => {
                    const filteredItems = items;
                    if (filteredItems.length === 0) return null;
                    return (
                      <div
                        className="ContentCollection"
                        data-display-type="grid"
                      >
                        <header className="ContentCollection__header">
                          {title} {`(${filteredItems.length})`}
                        </header>
                        <div>
                          <div className="ContentCollection__items">
                            {filteredItems.map(item => (
                              <ContentCard {...item} />
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {sections[0].items.length === 0 &&
                    sections[1].items.length === 0 &&
                    sections[2].items.length === 0 && (
                      <div className="SearhPage__NoResults">
                        {isLoading ? (
                          <span>Loading...</span>
                        ) : (
                          <span>No results!</span>
                        )}
                      </div>
                    )}
                </div>
              )}
            </div>
            <div className="SearchPage__character-container">
              {bottomImageSlugs.map(slug => (
                <img
                  className="SearchPage__character"
                  src={`${settings.ASSETS_URL}/img/characters/${slug}.svg`}
                  alt={slug}
                />
              ))}
            </div>
          </div>

          <aside className="ContentBlock__aside" style={{ paddingTop: '8em' }}>
            <VideoSiderailPlayer />
            <RampUnit type="med_rect_atf" id="siderec" />
            <RampUnit type="med_rect_btf" id="sideflex" />
          </aside>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => {
  const slug = props.params.bookID;
  const booksList = reducers.getMediaLists(state, 'BooksLanding', '/books');
  const gamesList = reducers.getMediaLists(state, 'GamesLanding', '/games');
  const videosList = reducers.getMediaLists(state, 'VideosLanding', '/videos');
  return {
    slug,
    isFetching: reducers.getIsPageFetching(state),
    booksList: booksList ? booksList[0].items : [],
    gamesList: gamesList ? gamesList[0].items : [],
    videosList: videosList ? videosList[0].items : [],
    isLoading: !!(!videosList || !booksList || !gamesList),
    errors: reducers.getErrors(state),
  };
};

const allActions = {
  ...mediaActions,
  ...listsActions,
};

const SearchPageComponent = connect(mapStateToProps, allActions)(SearchPage);

export default withLocationWrapper(SearchPageComponent);
